/**
 * @generated SignedSource<<644302913b3d2105eba0527258fbbb95>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyRespTopNavFilters_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterItemLocation_viewer">;
  readonly " $fragmentType": "BuyRespTopNavFilters_viewer";
};
export type BuyRespTopNavFilters_viewer$key = {
  readonly " $data"?: BuyRespTopNavFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyRespTopNavFilters_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyRespTopNavFilters_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemLocation_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "dd8e20206de0598390c9d90b89cd75f0";

export default node;
